import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from '@fortawesome/free-solid-svg-icons'


const StyledSecondaryButton = styled.button`
    width: 150px;
    height: 35px;
    background-color: white;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 12px;
    font-weight: 600;
    border: solid 1px ${(props) => props.theme.color.primaryblue};
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    cursor: pointer;
    padding-bottom: 4px;
    user-select: none;
    border-radius: 2px;

    &:hover:enabled {
        background-color: ${(props) => props.theme.color.secondaryhover};
    }
    :active:enabled {
        box-shadow: 0 0 3px ${(props) => props.theme.color.primaryhover};
    }
    :disabled {
        color: ${(props) => props.theme.color.gray};
        background-color: ${(props) => props.theme.color.disabledgray};
        border: solid 1px ${(props) => props.theme.color.bordergray};
    }
`;

function SecondaryButton(props) {

    const {caption, isLoading, ...restProps} = props;

    return (
        <StyledSecondaryButton {...restProps}>
            {isLoading && <FontAwesomeIcon icon={faSpinner} className='spinner' spin style={{marginRight: 5}}></FontAwesomeIcon>}
            {caption}
        </StyledSecondaryButton>
    )
}

export default SecondaryButton;